import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

import useTranslation from '../../hooks/use_translation';
import Link from '../framework/link';
import Suspense from '../framework/suspense';

const Widget = ({ className, theme = 'light', type = 'normal' }) => {
	const reference = useRef(null);
	const { language } = useTranslation('component_script_trustpilot');

	const types = {
		carousel: {
			class: 'carousel',
			data_stars: '1,2,3,4,5',
			height: '140px',
			template_id: '53aa8912dec7e10d38f59f36',
			width: '100%',
		},
		micro_star: {
			class: 'micro-star',
			height: '24px',
			template_id: '5419b732fbfb950b10de65e5',
			width: '100%',
		},
		micro_trust_score: {
			class: 'micro-trust-score',
			height: '20px',
			template_id: '5419b637fa0340045cd0c936',
			width: '100%',
		},
		mini: {
			class: 'mini',
			height: '150px',
			template_id: '53aa8807dec7e10d38f59f32',
			width: '100%',
		},
		normal: {
			class: 'normal',
			height: '24px',
			template_id: '5419b732fbfb950b10de65e5',
			width: '100%',
		},
		starter: {
			class: 'starter',
			height: '100%',
			template_id: '5613c9cde69ddc09340c6beb',
			width: '100%',
		},
	};

	useEffect(() => {
		if (typeof window !== 'undefined' && window?.Trustpilot?.loadFromElement) {
			window.Trustpilot.loadFromElement(reference.current, true);
		}
	}, []);

	const currentType = types[type];

	return (
		<div
			className={`trustpilot-widget ${className}`}
			data-businessunit-id="60b960ba0498090001ca9270"
			data-locale={language == 'en' ? 'en-US' : 'sv-SE'}
			data-style-height={types[type].height}
			data-style-width={types[type].width}
			data-template-id={types[type].template_id}
			{...(type === 'carousel' && { 'data-stars': currentType.data_stars })}
			data-theme={theme}
			ref={reference}
		>
			<Link
				rel="noopener noreferrer"
				target="_blank"
				to="https://www.trustpilot.com/review/testmottagningen.se"
			>
				{'Trustpilot'}
			</Link>
		</div>
	);
};

const Trustpilot = (props) => {
	return (
		<Suspense>
			<Widget {...props} />
		</Suspense>
	);
};

Widget.propTypes = {
	className: PropTypes.string,
	theme: PropTypes.string,
	type: PropTypes.string.isRequired,
};

export default Trustpilot;
